import {
  loadFolderContents,
  selectFolderViewItems,
} from '@explorer/actions/folders';

export const buildFoldersActions = storedState => {
  const actions = [];
  if (storedState.folders && storedState.folders.selectedFolderId) {
    // set what should be selected

    if (storedState.folders.viewItems) {
      actions.push(
        selectFolderViewItems({items: storedState.folders.viewItems})
      );
    }
    // backwards comp w. old state
    else if (storedState.folders.selectedItems) {
      const selectedItems = storedState.folders.selectedItems.map(
        item => item.name
      );
      actions.push(selectFolderViewItems({items: selectedItems}));
    }

    actions.push(
      loadFolderContents({
        id: storedState.folders.selectedFolderId,
      })
    );
  }
  return actions;
};
